import { render, staticRenderFns } from "./ShopingTrolleyForJdList.vue?vue&type=template&id=6c3a2656&scoped=true&"
import script from "./ShopingTrolleyForJdList.vue?vue&type=script&lang=js&"
export * from "./ShopingTrolleyForJdList.vue?vue&type=script&lang=js&"
import style0 from "./ShopingTrolleyForJdList.vue?vue&type=style&index=0&id=6c3a2656&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3a2656",
  null
  
)

export default component.exports